import React from 'react'

const Header = () =>{
    return(
        <div className="head-container">
            <h1>Movie Night</h1>
        </div>
    )
}

export default Header